module.exports = require('./lib/react-redux-ab-modules').default;
